module.exports = __webpack_public_path__ + "assets/phoenix-sales-recruiters-1.a73db8e0.png";